module.exports = __webpack_public_path__ + "img/tg_02 (10).200d2d24.jpg";